export const filterTypes = {
  selectBox: "select-box",
  textBox: "text-box",
  datePicker: "date-picker",
  multiSelect: "multi-select",
  reactSelect: "select-react",
  text: "text",
  button: "button",
  dateTimePicker: "datetime-picker"
};
